import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BookingIntro from './BookingIntro.jsx';
import BookingDetails from './BookingDetails.jsx';
import PaymentDetails from './PaymentDetails.jsx';
import PrivacyTermsTab from './PrivacyTermsTab.jsx';
import Itinerary from './Itinerary.jsx';
import DetailedOverview from './DetailedOverview.jsx';
import TravellerDetails from './TravellerIdentity.jsx';
import VisaInsurance from './VisaInsurance.jsx';
import Footer from './Footer.jsx';
import './BookingInfo.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function BookingInfo() {
  return (
      <div>
        <div className='booking-details-panel'>
          <BookingIntro />
          <BookingDetails />
          <PaymentDetails />
          <TravellerDetails />
          <Itinerary />
          <DetailedOverview />
        </div>
        <PrivacyTermsTab />
        <VisaInsurance />
        <Footer />
      </div>
  );
}

export default BookingInfo;
